export function wrapSystemMessage(text: string): string {
  if (text.trim() === "") {
    throw new Error("wrapSystemMessage: text must be non-empty");
  }
  return `<system_message>${text}</system_message>`;
}
